import 'styles/hantsContactUsForm.scss'
import {Urls} from '../constants'

(function () {
    /* global $ */
    "use strict";


    var mountNode = document.getElementById("app");
    var loggedIn = false;

    $.fn.widthPerc = function () {
        var parent = this.parent();
        //  return ~~((this.width()/parent.width())*100)+"%";
        return ~~((this.width() / parent.width()) * 100);
    }


    function checkAuth() {
        $.getJSON('/s4s/Auth/GetUserInfoJson')
            .done(function (data) {

                if (data.LaBcgId !== null) {
                    loggedIn = true;
                }

                var fillFormComponentApi = new FillFormComponentApi({
                    apiBaseUrl: "/s4s/api/",
                    formId: Urls.contact_form_hants_id,
                    mode: "",
                    isTemp: false,
                    finishAction: "",
                    closeUrl: '/s4s/',
                    tempFormId: '',
                    isPrintView: false,
                    isAuthenticated: loggedIn,
                    signUpUrl: '/s4s/SignUp',
                    isFillFormData: false
                });

                fillFormComponentApi.mount(mountNode);

                contrastClasses();

            });
    }



    function contrastClasses(){
        $('.progress-container').hide()
         // Contrast
         $('#app').addClass('pcg-contrast__bg-main')
         $('label').each(function () {
             $(this).addClass('pcg-contrast__color-main')
         })
         $('.section').addClass('pcg-contrast__color-main')
         $('.question-type-label p').addClass('pcg-contrast__color-main')
         $('.custom-form-answer p').addClass('pcg-contrast__color-main')
         $('.characters-countdown-input_label').addClass('pcg-contrast__color-main')
         $('.form-navigation-btns__btn_finish').addClass('pcg-contrast__btn')
         $('.form-header__action-buttons button').addClass('pcg-contrast__btn')

    }


    $('body').on('click', function () {
        contrastClasses();
    });

    $('.form-navigation-btns__btn_finish').on('click', function(){
        contrastClasses();
    });
    


  
   

    $(document).ready(function () {

        // Nav button renamed
        setTimeout(function () {
            $('.form-navigation-btns__button:contains("Save")').addClass("save-btn");
            $('.form-navigation-btns__button:contains("Finish")').addClass("finish-btn");
            $('.form-navigation-btns__button:contains("Next")').addClass("next-btn");
            $('.form-navigation-btns__button:contains("Close")').addClass("close-btn");
            $('.form-navigation-btns__button:contains("Previous")').addClass("prev-btn");
            $('.form-navigation-btns__button:contains("Finish (without saving)")').addClass("finish-w-no-Save-btn");

            $('#app .form-navigation-btns__btn_finish').text("Submit");

            // Add tabindex
            $('.form-header__title').attr('tabindex','0')
            $('.question-type-label').attr('tabindex','0')
            $('.question-type-radio legend').attr('tabindex','0')
            $('.question-type-radio .form-radio__option').attr('tabindex','0')     
            contrastClasses() 
           

        }, 500);

    });



    checkAuth();
	
 

    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
        },

        adjustDom: function () {            
			contrastClasses() 
        },

        bindUIActions: function () {

        },

        unload: function () {},
    };

    Attributes.init();
})();














